export default {
    PRECHAT: 'PRECHAT',
    CHAT: 'CHAT',
    QUEUE: 'QUEUE',
    POSTCHAT: 'POSTCHAT',
}


// WEBPACK FOOTER //
// ./src/constants/chatScreens.js